import React, { ReactNode } from 'react';
import { addAlpha } from '../utils';
import styles from './Stepper.module.css';

interface StepperProps {
  activeStep: number;
  partialFill?: boolean;
  partialWidth?: string;
  exception?: boolean;
  icons: {
    activeIcons: ReactNode[];
    inactiveIcons: ReactNode[];
    error: ReactNode[];
  };
  stepperColor: string;
}

const Stepper = ({
  activeStep,
  partialFill = false,
  partialWidth = '30%',
  exception = false,
  icons,
  stepperColor,
}: StepperProps) => {
  const getWidth = (index: number): string => {
    if (index === activeStep + 1) {
      return partialFill ? partialWidth : '0';
    }
    return index <= activeStep ? '100%' : '0';
  };

  const getIcon = (index: number): ReactNode => {
    if (exception) {
      return icons.error[index];
    }
    if (index <= activeStep) {
      return icons.activeIcons[index];
    }

    return icons.inactiveIcons[index] ?? <></>;
  };

  return (
    <div className={styles.container}>
      {Array.from(
        Array(exception ? icons.error.length : icons.activeIcons.length).keys(),
      ).map((index) => (
        <div
          key={index}
          className={styles.stepContainer}
          style={{ width: index === 0 ? 'auto' : '100%' }}
        >
          <div className={styles.icon}>{getIcon(index)}</div>
          {index !== 0 && (
            <div
              className={styles.progressContainer}
              style={{
                justifyContent: exception ? 'center' : 'start',
                backgroundColor: addAlpha(stepperColor, 0.2),
              }}
            >
              <span
                className={styles.filledProgress}
                style={{
                  width: getWidth(index),
                  borderColor: stepperColor,
                }}
              />
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Stepper;
